import { styled, css } from "styled-components";
import { mobileBreakPointCSS } from "../defaults/theme.js";
import { Spacing } from "../types/theme.js";
import type { BackgroundColor } from "../types/theme.js";
import { surfaceColorMap } from "../util/styles.js";

export enum VerticalSpacerSize {
  Mobile = "m",
  Desktop = "l",
}

export enum HorizontalSpacerSize {
  Mobile = "xs",
  Desktop = "l",
}

interface VerticalSpacerProps {
  mobileGutter?: keyof Spacing;
  desktopGutter?: keyof Spacing;
}

interface HorizontalSpacerProps extends VerticalSpacerProps {}

export const VerticalSpacer = styled.div<VerticalSpacerProps>`
  margin: ${({ theme, mobileGutter }) => mobileGutter ? theme.spacing[mobileGutter] : theme.spacing[VerticalSpacerSize.Mobile]} 0;

  @media (min-width: ${mobileBreakPointCSS}) {
    margin: ${({ theme, desktopGutter }) => desktopGutter ? theme.spacing[desktopGutter] : theme.spacing[VerticalSpacerSize.Desktop]} 0;
  }
`;

export const HorizontalSpacer = styled.div<HorizontalSpacerProps>`
  padding: 0 10px;
`;

export interface ConstrainerProps {
  $width?: "small" | "medium";
}

export const Constrainer = styled.div<ConstrainerProps>`
  margin: 0 auto;
  max-width: 1100px;

  ${(props) =>
    props.$width === "small" &&
    css`
      max-width: 600px;
    `};
`;

export const SectionBackground = styled.div<{ $background?: BackgroundColor }>`
  background: ${(p) => (p.$background ? surfaceColorMap[p.$background] : undefined)};
  width: 100%;
`;
